import React, { useState } from 'react';
import { App, Button, Popconfirm, Popover, Space, Tag, Typography, Upload } from 'antd';
import { DeleteOutlined, HistoryOutlined, UploadOutlined } from '@ant-design/icons';
import { hataMesaji, markaApi } from './markaApi';

const { Text } = Typography;

/** Yuvanın kabul ettiği uzantılar (backend services/marka_portal.py yuva_kurali ile aynı). */
export const kabul = (yuva) => {
  if (yuva.startsWith('logo/')) return `.${yuva.split('/')[3]}`;
  if (yuva.startsWith('urun/') || ['antetli/onizleme', 'kurumsal_set/jpg'].includes(yuva)) return '.jpg,.jpeg';
  if (['kartvizit/on', 'kartvizit/arka'].includes(yuva)) return '.png,.jpg,.jpeg';
  if (yuva.startsWith('font/')) return '.woff2';
  return {
    'antetli/docx': '.docx', 'antetli/pdf': '.pdf', 'imza/html': '.html,.htm', 'imza/hosted': '.html,.htm',
    'imza/logo': '.png', 'kurumsal_set/svg': '.svg', 'kartvizit/pdf': '.pdf',
  }[yuva] || '';
};

const kb = (b) => (b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

/**
 * Tek dosya yuvası: güncel dosya, yükle/değiştir, geçmiş (geri al), boşalt.
 * Dosyalar silinmez: değiştirilen/boşaltılan sürüm geçmişte kalır.
 */
export default function Yuva({ slug, yuva, etiket, dosya, kucuk = false, resim = false, onDegisti, urunEtiketi }) {
  const { message } = App.useApp();
  const [mesgul, setMesgul] = useState(false);
  const guncel = dosya && dosya.url ? dosya : null;
  const gecmis = dosya?.gecmis || [];

  const calistir = async (is, basari) => {
    setMesgul(true);
    try {
      const c = await is();
      if (basari) message.success(basari);
      onDegisti?.(c);
    } catch (e) {
      message.error(hataMesaji(e), 6);
    } finally {
      setMesgul(false);
    }
  };

  const gecmisListesi = (
    <div style={{ maxWidth: 420 }}>
      {gecmis.length === 0 && <Text type="secondary">Geçmiş yok</Text>}
      {gecmis.map((g) => (
        <div key={g.sha256 + (g.tarih || '')} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 0' }}>
          <a href={g.url} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>{g.dosya_adi}</a>
          <Text type="secondary" style={{ fontSize: 12 }}>{g.tarih}</Text>
          <Popconfirm title="Bu sürüm güncel yapılsın mı?" onConfirm={() => calistir(() => markaApi.geriAl(slug, yuva, g.sha256), 'Eski sürüm geri getirildi')}>
            <Button size="small">Geri al</Button>
          </Popconfirm>
        </div>
      ))}
    </div>
  );

  const yukleDugmesi = (
    <Upload
      accept={kabul(yuva)}
      showUploadList={false}
      beforeUpload={(f) => { calistir(() => markaApi.dosyaYukle(slug, yuva, f, urunEtiketi), 'Yüklendi'); return false; }}
    >
      <Button size="small" icon={<UploadOutlined />} loading={mesgul} type={guncel ? 'default' : 'primary'} ghost={!guncel}>
        {kucuk ? '' : (guncel ? 'Değiştir' : 'Yükle')}
      </Button>
    </Upload>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 32 }}>
      {etiket && <Text style={{ width: kucuk ? 'auto' : 150, flex: 'none' }}>{etiket}</Text>}
      {resim && guncel && (
        <a href={guncel.url} target="_blank" rel="noopener noreferrer">
          <img src={guncel.url} alt="" style={{ width: 44, height: 44, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee' }} />
        </a>
      )}
      <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {guncel ? (
          kucuk ? <a href={guncel.url} target="_blank" rel="noopener noreferrer"><Tag color="green">var</Tag></a> : (
            <Space size={6}>
              <a href={guncel.url} target="_blank" rel="noopener noreferrer">{guncel.dosya_adi}</a>
              <Text type="secondary" style={{ fontSize: 12 }}>{kb(guncel.boyut || 0)} · {guncel.tarih}</Text>
            </Space>
          )
        ) : <Tag color="default">yok</Tag>}
      </div>
      <Space size={4}>
        {yukleDugmesi}
        {gecmis.length > 0 && (
          <Popover content={gecmisListesi} title="Önceki sürümler" trigger="click">
            <Button size="small" icon={<HistoryOutlined />}>{kucuk ? gecmis.length : `Geçmiş (${gecmis.length})`}</Button>
          </Popover>
        )}
        {guncel && !yuva.endsWith('/renkli/svg') && (
          <Popconfirm title="Yuva boşaltılsın mı? (Dosya geçmişte kalır)" onConfirm={() => calistir(() => markaApi.dosyaBosalt(slug, yuva), 'Boşaltıldı')}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        )}
      </Space>
    </div>
  );
}
